<div class="get-care-now-title-container-web">{{title}}</div>
<div class="get-care-now-description-container-web">
    <div>{{description}}</div>
</div>
<div  *ngIf="quickCareOptions != null && quickCareOptions.length > 0" class="get-care-now-scroll-container-web">
    <app-ask-a-doctor-option-card
      *ngFor="let option of quickCareOptions"
      [title]="option.name"
      [waitTime]="option.waitTime"
      [photoUrl]="option.photoURL"
      [deepLink]="option.deepLink"
      [deepLinkNoAuth]="option.deepLinkNoAuth"
      [symptomID]="option.symptomID"
      [locale]="locale">
    </app-ask-a-doctor-option-card>
</div>
<div *ngIf="quickCareOptions != null && quickCareOptions.length > 0" style="align-items: center; justify-content: center; display: flex; padding: 24px;">
  <button mat-button class="action-button-secondary" style="border-radius: 12px;" (click)="showMeMore()">{{showMoreText}}</button>
</div>
<div *ngIf="!quickCareOptions || quickCareOptions.length === 0" style="width: 190px; height:190px; margin-top: 16px; margin-left: 16px;">
    <ng-container>
        <div class="get-care-now-loading-spinner-mobile">
            <mat-spinner></mat-spinner>
        </div>
    </ng-container>
</div>

